import { useScrollReveal } from '@/hooks/useScrollReveal';

const warehouseCards = [
  { name: 'Kochi Cold Storage Hub', tech: 'IQF Freezing', capacity: 85, cert: 'HACCP-Certified', color: 'border-secondary-500' },
  { name: 'Gujarat FreezePort', tech: 'Blast Freezing', capacity: 92, cert: 'Export-Grade', color: 'border-primary-500' },
  { name: 'Nagpur ColdChain Centre', tech: 'Deep-Freeze Storage', capacity: 60, cert: 'Verified', color: 'border-accent-500' },
  { name: 'Vizag Marine Freezer', tech: 'IQF + Cold Storage', capacity: 78, cert: 'HACCP-Certified', color: 'border-secondary-500' },
];

const techTypes = [
  { icon: 'ri-snowflake-line', label: 'Blast Freezing', desc: '-35°C to -40°C rapid freezing tunnels' },
  { icon: 'ri-contrast-drop-line', label: 'IQF Freezing', desc: 'Individual quick freezing for produce integrity' },
  { icon: 'ri-temp-cold-line', label: 'Cold Storage', desc: '-18°C to -22°C holding and staging' },
  { icon: 'ri-thermometer-line', label: 'Deep-Freeze', desc: '-40°C and below long-term preservation' },
];

export default function CapacityMapping() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-600 uppercase tracking-widest mb-4">
            Network Intelligence
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            What We Map
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto">
            Every facility on the network is profiled across freezing technology, throughput, utilisation, certifications, and delivery radius — so matching is precise, not guesswork.
          </p>
        </div>

        {/* Dashboard mockup */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {warehouseCards.map((wh) => (
            <div key={wh.name} className={`bg-card-50 rounded-xl border ${wh.color} border-t-2 overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 card-animate`}>
              <div className="p-5">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="font-heading font-bold text-sm text-primary-700">{wh.name}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">{wh.cert}</span>
                </div>
                <div className="text-xs text-foreground-400 mb-3">{wh.tech}</div>
                <div>
                  <div className="flex items-center justify-between text-xs text-foreground-500 mb-1.5">
                    <span>Utilisation</span>
                    <span className="font-semibold text-primary-700">{wh.capacity}%</span>
                  </div>
                  <div className="w-full h-1.5 bg-background-200 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full transition-all duration-1000 ${wh.capacity > 80 ? 'bg-accent-500' : 'bg-secondary-500'}`}
                      style={{ width: `${wh.capacity}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Technology grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {techTypes.map((tech) => (
            <div key={tech.label} className="group flex items-start gap-4 p-4 rounded-xl bg-card-50 border border-card-200 shadow-sm card-animate">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 animate-icon-float icon-hover-pop">
                <i className={`${tech.icon} text-lg`}></i>
              </div>
              <div>
                <div className="font-heading font-semibold text-sm text-primary-700 mb-0.5">{tech.label}</div>
                <div className="text-xs text-foreground-500 leading-relaxed">{tech.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}